import React from 'react';
import { useTranslation } from 'react-i18next';
import { useCgmDisplayMode } from '../contexts/CgmDisplayModeContext';

const CgmModeSwitcher: React.FC = () => {
  const { t } = useTranslation('common');
  const { mode, setMode } = useCgmDisplayMode();

  return (
    <div
      className="inline-flex rounded-xl border border-[var(--border-light)] bg-[var(--surface)] p-1 shadow-sm"
      role="group"
      aria-label={t('cgmDisplayMode')}
      data-testid="cgm-display-mode-switcher"
    >
      <button
        type="button"
        onClick={() => setMode('standard')}
        aria-pressed={mode === 'standard'}
        className={`min-h-[40px] rounded-lg px-3 text-sm font-semibold transition-colors ${
          mode === 'standard'
            ? 'bg-[var(--color-primary)] text-white'
            : 'text-[var(--text-secondary)] hover:bg-[var(--bg-secondary)]'
        }`}
      >
        {t('cgmDisplayStandard')}
      </button>
      <button
        type="button"
        onClick={() => setMode('expert')}
        aria-pressed={mode === 'expert'}
        className={`min-h-[40px] rounded-lg px-3 text-sm font-semibold transition-colors ${
          mode === 'expert'
            ? 'bg-[var(--color-primary)] text-white'
            : 'text-[var(--text-secondary)] hover:bg-[var(--bg-secondary)]'
        }`}
      >
        {t('cgmDisplayExpert')}
      </button>
    </div>
  );
};

export default CgmModeSwitcher;
